<template>
  <div class="pa-2">
    <DxDataGrid
      :data-source="dataSource"
      :show-borders="true"
      :allow-column-resizing="true"
      :column-auto-width="true"
      :row-alternation-enabled="true"
    >
      <DxEditing :allow-adding="true" :allow-updating="true" :allow-deleting="true" mode="popup">
        <DxPopup :show-title="true" title="Tip document HR" :width="460" :height="440" />
        <DxForm>
          <DxItem data-field="Cod" :is-required="true" />
          <DxItem data-field="Denumire" :is-required="true" />
          <DxItem data-field="Descriere" editor-type="dxTextArea" :editor-options="{ height: 80 }" />
          <DxItem data-field="NecesitaFisier" editor-type="dxCheckBox" />
          <DxItem data-field="IsActiv" editor-type="dxCheckBox" />
        </DxForm>
      </DxEditing>

      <DxColumn data-field="Cod" caption="Cod" :width="120" />
      <DxColumn data-field="Denumire" caption="Denumire" />
      <DxColumn data-field="Descriere" caption="Descriere" />
      <DxColumn data-field="NecesitaFisier" caption="Necesită fișier" data-type="boolean" :width="130" />
      <DxColumn data-field="IsActiv" caption="Activ" data-type="boolean" :width="80" />

      <DxToolbar>
        <DxItem location="before" name="addRowButton" />
        <DxItem location="after" name="searchPanel" />
        <DxItem location="after">
          <template #default>
            <DxButton icon="refresh" @click="dataSource.reload()" />
          </template>
        </DxItem>
      </DxToolbar>

      <DxSearchPanel :visible="true" :width="200" placeholder="Caută..." />
      <DxPaging :page-size="20" />
      <DxFilterRow :visible="true" />
    </DxDataGrid>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import {
  DxDataGrid, DxColumn, DxEditing, DxPopup, DxForm, DxItem,
  DxToolbar, DxSearchPanel, DxPaging, DxFilterRow
} from 'devextreme-vue/data-grid'
import { DxButton } from 'devextreme-vue/button'
import DataSource from 'devextreme/data/data_source'
import ODataStore from 'devextreme/data/odata/store'
import AppSettings from '@/settings/appSettings'

export default defineComponent({
  name: 'TipuriDocumenteHR',
  components: { DxDataGrid, DxColumn, DxEditing, DxPopup, DxForm, DxItem, DxToolbar, DxSearchPanel, DxPaging, DxFilterRow, DxButton },
  data() {
    return {
      dataSource: new DataSource({
        store: new ODataStore({
          url: AppSettings.API_Url_PortalHROdata + 'PORTAL_DocumentTypes',
          key: 'ID',
          version: 4,
          beforeSend: (e: any) => {
            e.headers = { Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt') }
          }
        })
      })
    }
  }
})
</script>
